import { computed } from 'mobx'
import {
  getDisplayFormatter,
  getTableColumns,
  getTableHeader,
  getType,
  getSubtype,
  getFieldConfig
} from './getters'
import {initializeValue} from './initializeValue'
import { ColumnsConfig, DEFAULT_TABLE_CONFIG } from './decorators/constants';

type GenericObj = {[key: string]: any}

export type SchemerModelOptions = {
  copy?: boolean
  transform?: (source: GenericObj) => GenericObj
} 

// const DEFAULT_OPTIONS = {
//   copy: true
// }

const copyInitial = (target: SchemerModel, source: {[key: string]: any}) => {

  Object.assign(target, source)

  for (const prop in target) {
    const fieldConfig = getFieldConfig(target, prop)
    if (fieldConfig) {
      target[prop] = initializeValue(target[prop], fieldConfig)
    }
  }
}


class SchemerModel {

  // Template properties that may be set by consumers

  // classNames?: string
  // get classNames () : string { return '' }
  set classNames (arg) {}
  // columnPrefs?: Map<string, {width?: number, fixed?: boolean}>
  // get columnPrefs () : Map<string, {width?: number, fixed?: boolean}> { return '' }
  set columnPrefs (arg: any) {}
  set itemActions (arg) {}
  set itemActionsWidth (arg) {}

  constructor(initial: object = {}, options: SchemerModelOptions = {}) {
    if (options.transform && initial) {
      initial = options.transform(initial)
    }

    const skipCopy = options.copy === false
    if (!skipCopy && initial) {
      copyInitial(this, initial)
    }
  }

  @computed 
  get tableColumns () : ColumnsConfig {
    const allColumns = getTableColumns(this)
    const colPrefs = this.columnPrefs
    
    if (!colPrefs) {
      return allColumns
    }

    let output = new Map()
    colPrefs.forEach((value, key) => {
      if (allColumns.has(key)) {
        output.set(
          key,
          {
            ...DEFAULT_TABLE_CONFIG,
            ...(allColumns.get(key) || {}),
            ...value
          }
        )
      }
      else {
        console.warn(`Invalid column key: ${key}`)
      }
    })
    
    return output
  }

  // Prop getters
  getHeader (propName: string) {
    return getTableHeader(this, propName)
  }

  getFormatter (propName: string) {
    return getDisplayFormatter(this, propName)
  }

  getFieldConfig (propName: string) {
    return getFieldConfig(this, propName)
  }

  getType (propName: string) {
    return getType(this, propName)
  }

  getSubtype (propName: string) {
    return getSubtype(this, propName)
  }
}

export default SchemerModel